import { render, staticRenderFns } from "./VoucherDetailModal.vue?vue&type=template&id=2e895c7e&scoped=true"
import script from "./VoucherDetailModal.vue?vue&type=script&lang=js"
export * from "./VoucherDetailModal.vue?vue&type=script&lang=js"
import style0 from "./VoucherDetailModal.vue?vue&type=style&index=0&id=2e895c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e895c7e",
  null
  
)

export default component.exports